import { render, staticRenderFns } from "./u-btn-flat-tile.vue?vue&type=template&id=32ba10dc&scoped=true&"
import script from "./u-btn-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-btn-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba10dc",
  null
  
)

export default component.exports